import React from 'react';
import { Menu } from 'antd';

function ModalAnchor({ navRefs, categoryOrder, listCategory, style = {} }) {
  const handleClick = ({ key }) => {
    navRefs[key].scrollIntoView({ behavior: 'smooth' });
  };

  const items = categoryOrder.map((categoryKey) => ({
    label: listCategory[categoryKey] || categoryKey,
    key: categoryKey,
  }));

  return (
    <Menu
      style={{ minWidth: '150px', ...style }}
      items={items}
      onClick={handleClick}
      selectable={false}
    />
  );
}

export default ModalAnchor;
